<template>
  <el-menu
    mode="horizontal"
    @select="handleMenuSelect"
    ref="headerMenu"
    :unique-opened="true"
    :default-active="active"
  >
    <template v-for="(menu, menuIndex) in menuHeader">
      <d2-layout-header-aside-menu-item
        v-if="menu.children === undefined"
        :menu="menu"
        :key="menuIndex"
      />
      <d2-layout-header-aside-menu-sub
        v-else
        :menu="menu"
        :key="menuIndex"
      />
    </template>
  </el-menu>
</template>

<script>
import menuMixin from '../mixin/menu'
import d2LayoutMainMenuItem from '../components/menu-item/index.vue'
import d2LayoutMainMenuSub from '../components/menu-sub/index.vue'

export default {
  name: 'ZebraMenuHeader',
  mixins: [menuMixin],
  components: {
    'd2-layout-header-aside-menu-item': d2LayoutMainMenuItem,
    'd2-layout-header-aside-menu-sub': d2LayoutMainMenuSub
  },
  props: {
    menuHeader: {
      type: Array,
      required: true
    },
    currentAppInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      active: ''
    }
  },
  mounted() {
    this.$children[0].$parent = this.$parent
  },
  methods: {
    // 处理菜单项点击事件
    handleMenuSelect(key, keyPath) {
      // 向外发射事件，告诉父组件点击了哪个菜单项
      this.$emit('menu-item-clicked', key)

      // 可以在这里直接跳转（如果需要更细粒度控制，建议交给父组件处理）
      if (key && key.startsWith('/')) {
        this.$router.push(key).catch(() => {})
      }
    }
  },
  watch: {
    '$route': {
      handler(val) {
        if (this.currentAppInfo.url) {
          this.active = this.currentAppInfo.url
        } else {
          this.active = val.path
          if (this.active.endsWith('/')) {
            this.active = this.active.substr(0, this.active.length - 1)
          }
        }

        this.$nextTick(() => {
          if (this.menuHeader.length > 0) {
            this.$refs.headerMenu.activeIndex = this.active
          }
        })
      },
      immediate: true
    }
  }
}
</script>